import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import ScrollToTop from "./components/ScrollToTop";
// import Loader from "./components/Loader";
import WhatsAppFloat  from "./components/WhatsAppFloat";
import DeleteAccount from "./pages/delete-account";
import RoomBuddyHome from "./components/RoomBuddyHome";


function App() {

  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => setLoading(false), 1500);
  //   return () => clearTimeout(timer);
  // }, []);

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <BrowserRouter>
      <ScrollToTop />
    
      <main>
        <Routes>
          <Route path="/" element={<RoomBuddyHome />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
           <Route path="/termsConditions" element={<TermsConditions />} />
           <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
}

export default App;
 

